<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="修改"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="12" :offset="6">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <el-form label-width="100px">
              <el-row>

                <el-col :span="24">
                  <validation-provider rules="required" name="名称" v-slot="{ errors }">
                    <el-form-item label="名称" :error="errors[0]">
                      <el-input v-model="form.name" clearable placeholder="请填写名称"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="支付价格" v-slot="{ errors }">
                    <el-form-item label="支付价格" :error="errors[0]">
                      <el-input type="number" v-model="form.pay_price" clearable
                                placeholder="请填写支付价格"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="原价" v-slot="{ errors }">
                    <el-form-item label="原价" :error="errors[0]">
                      <el-input type="number" v-model="form.pay_raw_price" clearable
                                placeholder="请填写原价"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="有效时长" v-slot="{ errors }">
                    <el-form-item label="有效时长(天)" :error="errors[0]">
                      <el-input-number v-model="form.duration" :min="1" :max="100000"></el-input-number>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="排序数字" v-slot="{ errors }">
                    <el-form-item label="排序数字" :error="errors[0]">
                      <el-input-number v-model="form.sort" :min="1" :max="1000"></el-input-number>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" :disabled="submitIng" @click="handleSubmit(onSubmit)">
                      {{ submitIng ? '提交中...' : '提交' }}
                    </el-button>
                    <el-button @click="closeHandle">取消</el-button>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
          </validation-observer>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: ''
      },
      detail: {},
      form: {
        id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      },
      submitIng: false,
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {
  },
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.form = {
        id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      }
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminSchemeUpdateDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
            _this.form = JSON.parse(JSON.stringify(res.detail))
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    onSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.form.id = _this.query.id;
      _this.$apiAdmin.adminSchemeUpdate(_this.form)
          .then((res) => {
            _this.submitIng = false;
            _this.closeHandle();
            _this.$message.success('修改成功')
            _this.$emit('finish', {
              type_id: _this.detail.type_id,
            })
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg)
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.form = {
        id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      }
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>